export default function(location: Location) {
  const path = `${location.origin}/material`
  const regx = new RegExp(path);
  const currentPath = location.origin + location.pathname
  return regx.test(currentPath);
  // return /material/.test(location.href);
}
